<template>
  <v-container fluid
               class="tfb-container">
    <h1 class="tfb-title-text-medium text-darker-blue text-uppercase">
      Premium Finance Payment
    </h1>
    <v-row>
      <v-col cols="12">
        <v-container fluid
                     class="drop-shadow tfb-smaller-container background-white tfb-bottom-form-margin">
          <div v-if="!showForm && !showReview && !showFinal">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Terms &amp; Conditions
                </h2>
              </v-col>
            </v-row>
            <premium-finance-terms-conditions></premium-finance-terms-conditions>
            <ValidationObserver ref="obv"
                                v-slot="{ handleSubmit }">
              <v-form ref="verifyForm"
                      @submit.stop.prevent="handleSubmit(acceptTerms)">
                <v-row>
                  <v-col cols="12">
                    <text-input :rules="memberRules"
                                label="Member Number"
                                autocapitalize="characters"
                                minlength="4"
                                maxlength="6"
                                v-model="verifyForm.memberNumber"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn block
                           @click="cancelPayment()"
                           class="tfb-button background-red">Cancel</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn block
                           :disabled="formDisabled"
                           type="submit"
                           class="tfb-button background-red">Submit</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </div>
          <div v-if="showForm">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Make a Payment
                </h2>
              </v-col>
            </v-row>
            <!-- Display pre-filled form -->
            <ValidationObserver ref="obvpay" v-slot="{ handleSubmit }">
              <v-form ref="paymentForm"
                      @submit.stop.prevent="handleSubmit(authPayment)">
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|routing_number|confirmed:routing|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Bank Routing Number"
                                v-model="paymentForm.routingNumber"
                                @blur="getBankName()"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Confirm Bank Routing Number"
                                v-model="paymentForm.confirmRoutingNumber"
                                vid="routing"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required"
                                label="Bank Name"
                                disabled
                                v-model="bankName"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|confirmed:account|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Bank Account Number"
                                v-model="paymentForm.accountNumber"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|min:4|max:17"
                                minlength="4"
                                maxlength="17"
                                label="Confirm Bank Account Number"
                                v-model="paymentForm.confirmAccountNumber"
                                vid="account"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <select-input rules="required"
                                  label="Payment Type"
                                  :items="paymentTypeOptions"
                                  item-text="DisplayText"
                                  item-value="Value"
                                  v-model="paymentType"
                                  @change="paymentTypeChange()"></select-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <text-input rules="required|min:1|max:10|decimal"
                                label="Payment Amount"
                                type="number"
                                prefix="mdi-currency-usd"
                                :disabled="amountDisabled"
                                v-model="paymentForm.paymentAmount"></text-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn block
                           @click="cancelPayment()"
                           class="tfb-button background-red">Cancel</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn block
                           :disabled="formDisabled"
                           type="submit"
                           class="tfb-button background-red">Submit</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </div>
          <div v-if="showReview">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Authorization
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="tfb-title-text-smaller">Please review the entered transaction information.
                  <span class="tfb-title-text-smaller font-weight-bold">Your payment is not complete until you click the &ldquo;Approve&rdquo; button below.</span>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label class="font-weight-bold">Payment Date:</label> {{formatDate(paymentDate)}}<br />
                <label class="font-weight-bold">Contract Number:</label> {{contractNumber}}<br />
                <label class="font-weight-bold">Payment Amount:</label> {{formatMoney(paymentForm.paymentAmount, 2)}}<br />
                <label class="font-weight-bold">Routing Number:</label> {{paymentForm.routingNumber}}<br />
                <label class="font-weight-bold">Account Number:</label> {{paymentForm.accountNumber}}<br />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                By clicking &ldquo;Approve&rdquo;, I understand the payment cannot be revoked and that the listed amount
                will be drafted from the listed account as a one-time transaction.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn block
                       @click="cancelPayment()"
                       class="tfb-button background-red">Cancel</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block
                       @click="makePayment()"
                       class="tfb-button background-red">Approve</v-btn>
              </v-col>
            </v-row>
          </div>
          <div v-if="showFinal">
            <v-row>
              <v-col cols="12">
                <h2 class="tfb-title-text-small text-darker-blue text-uppercase">
                  Confirmation
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="tfb-title-text-small">Your payment has been received.</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="tfb-title-text-smaller">
                  Your confirmation number is <span class="text-red font-weight-bold">{{confirmationNumber}}</span>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <label class="font-weight-bold">Payment Date:</label> {{formatDate(paymentDate)}}<br />
                <label class="font-weight-bold">Contract Number:</label> {{contractNumber}}<br />
                <label class="font-weight-bold">Confirmation Number:</label> {{confirmationNumber}}<br />
                <label class="font-weight-bold">Payment Amount:</label> {{formatMoney(paymentForm.paymentAmount, 2)}}<br />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn block
                       @click="printConfirmation()"
                       class="tfb-button background-red">Print</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block
                       @click="cancelPayment()"
                       class="tfb-button background-red">Return to Account Summary</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  /* eslint object-shorthand: 0 */
  import { dispatch } from 'vuex-pathify';
  import { ValidationObserver } from 'vee-validate';
  import tfbMetaInfo from '@/mixins/metaInfo';
  import tfbHelperMixin from '@/mixins/helpers';
  import { insuredAccessOnlyErrorMessage } from '@/mixins/errorMessages';
  import PremiumFinanceTermsConditions from './premiumfinance/TermsConditions.vue';
  /* eslint object-shorthand: 0 */

  export default {
    name: 'PremiumFinancePayments',
    mixins: [tfbMetaInfo, tfbHelperMixin],
    components: {
      ValidationObserver,
      PremiumFinanceTermsConditions,
    },
    data() {
      return {
        formDisabled: false,
        bankName: null,
        showForm: false,
        showReview: false,
        showFinal: false,
        paymentType: 'C',
        amountDisabled: true,
        contractNumber: null,
        paymentForm: {
          routingNumber: null,
          confirmRoutingNumber: null,
          accountNumber: null,
          confirmAccountNumber: null,
          paymentAmount: null,
        },
        verifyForm: {
          memberNumber: null,
        },
        memberRules: {
          required: true,
          min: 4,
          max: 6,
          is: '',
        },
        confirmationNumber: null,
        paymentDate: null,
        paymentTypeOptions: [{ Value: 'C', DisplayText: 'Current Payment' }, { Value: 'O', DisplayText: 'Other Payment' }],
      };
    },
    computed: {
      metaPageTitle() {
        return 'Premium Finance Payments | PolicyHolder';
      },
      metaUrl() {
        return `${process.env.VUE_APP_ROOT_URI}/policyholder/payments/premium-finance`;
      },
      emailAddress() {
        try {
          return this.$store.getters['member/emailAddress'];
        } catch (error) {
          return '';
        }
      },
      memberNumber() {
        try {
          return this.$store.getters['member/memberNumber'];
        } catch (error) {
          return '';
        }
      },
      pfPaymentRequest() {
        try {
          return this.$store.getters['payments/pfPaymentRequest'];
        } catch (error) {
          return null;
        }
      },
    },
    methods: {
      getBankName() {
        dispatch('app/clearErrorMessage');
        dispatch('payments/validateRoutingNumber', {
          sRoutingNumber: this.paymentForm.routingNumber, sTfbId: this.trackingId,
        })
          .then((validationResult) => {
            this.bankName = validationResult;
            if (!validationResult || validationResult === '') {
              this.paymentForm.routingNumber = null;
            }
          })
          .catch((error) => {
            dispatch('app/setErrorMessage', error.toString());
          });
      },
      paymentTypeChange() {
        if (this.paymentType === 'O' || (this.paymentType === 'C' && this.pfPaymentRequest.MinimumAmountDue === null)) {
          this.paymentForm.paymentAmount = '0.00';
          this.amountDisabled = false;
        } else {
          this.paymentForm.paymentAmount = this.pfPaymentRequest.MinimumAmountDue;
          this.amountDisabled = true;
        }
      },
      cancelPayment() {
        // Clear the request
        this.$store.commit('payments/SET_PF_PAYMENT_REQUEST', null);
        // Go back to Summary screen
        this.$router.push({ name: 'policyholderAccountSummary' });
      },
      acceptTerms() {
        // Accepted the terms, so show the payment form
        this.showForm = true;
      },
      authPayment() {
        dispatch('app/clearErrorMessage');
        this.paymentDate = new Date().toISOString();
        this.showFinal = false;
        this.showReview = true;
        this.showForm = false;
      },
      makePayment() {
        dispatch('app/clearErrorMessage');
        dispatch('app/setIsLoading', true);
        this.$store.dispatch('app/logToULS', {
          logLevel: 'Info',
          logMessage: `${this.pfPaymentRequest.ContractNumber}-${this.memberNumber}-${this.paymentForm.paymentAmount}`,
          fileName: 'PremiumFinancePayment.vue',
          methodName: 'makePayment-Start',
          trackerId: this.trackingId,
        });
        dispatch('payments/makePremiumFinancePayment', {
          sAccountNumber: this.paymentForm.accountNumber,
          sContractNumber: this.pfPaymentRequest.ContractNumber,
          sMemberNumber: this.memberNumber,
          sPaymentAmount: this.paymentForm.paymentAmount,
          sRoutingNumber: this.paymentForm.routingNumber,
          sTfbId: this.trackingId,
        })
          .then((paymentResult) => {
            this.$store.dispatch('app/logToULS', {
              logLevel: 'Info',
              logMessage: paymentResult,
              fileName: 'PremiumFinancePayment.vue',
              methodName: 'makePremiumFinancePayment-Response',
              trackerId: this.trackingId,
            });
            if (paymentResult.ConfirmationNumber && paymentResult.ConfirmationNumber !== '') {
              this.confirmationNumber = paymentResult.ConfirmationNumber;
              this.paymentDate = new Date().toISOString();
              this.showFinal = true;
              this.showReview = false;
              this.showForm = false;

              // Clear the request
              this.$store.commit('payments/SET_PF_PAYMENT_REQUEST', null);
              dispatch('app/setIsLoading', false);
            } else {
              dispatch('app/setErrorMessage', paymentResult.Result);
              dispatch('app/setIsLoading', false);
            }
          })
          .catch((error) => {
            this.$store.dispatch('app/logToULS', {
              logLevel: 'Error',
              logMessage: error,
              fileName: 'PremiumFinancePayment.vue',
              methodName: 'makePayment-Catch',
              trackerId: this.trackingId,
            });
            dispatch('app/setErrorMessage', error.toString());
            dispatch('app/setIsLoading', false);
          });
      },
      printConfirmation() {
        // TODO: Print confirmation
        window.print();
      },
    },
    watch: {
      'verifyForm.memberNumber'(val) {
        this.verifyForm.memberNumber = val.toUpperCase();
      },
    },
    mounted() {
      dispatch('app/clearErrorMessage');
      dispatch('app/setIsLoading', true);
      dispatch('app/doApplicationCheck', { sApplicationName: 'Payments', sTfbId: this.trackingId })
        .then((returnedStatus) => {
          if (returnedStatus === '') {
            if (!this.isLoggedIn) {
              // Invalid login - go back to login screen
              this.$router.push({ name: 'policyholderLogin' });
            } else if (!this.isMemberRole) {
              // Not the member, don't allow payment
              this.$store.dispatch('app/setErrorMessage', insuredAccessOnlyErrorMessage);
              this.$router.push({ name: 'policyholderAccountSummary' });
            } else if (this.pfPaymentRequest === null) {
              // No request values, push back to Summary screen
              this.$router.push({ name: 'policyholderAccountSummary' });
            } else {
              this.memberRules.is = this.memberNumber;
              this.contractNumber = this.pfPaymentRequest.ContractNumber;
              this.paymentForm.paymentAmount = this.pfPaymentRequest.MinimumAmountDue;
              this.amountDisabled = true;
            }
            dispatch('app/setIsLoading', false);
          } else {
            dispatch('app/setErrorMessage', returnedStatus);
            dispatch('app/setIsLoading', false);
            this.formDisabled = true;
          }
        })
        .catch((error) => {
          dispatch('app/setErrorMessage', error.toString());
          dispatch('app/setIsLoading', false);
        });
    },
  };
</script>
<style lang="scss">

</style>
